import { Link } from "react-router-dom";
import portrait from "../assets/pfp.jpg";
import { Arrow } from "./Shared";
import { whatsapp } from "./catalog";
import Reviews from "./Reviews";
import { JournalTeaser } from "./journal/Journal";
import Scene from "./observatory/Scene";
import PracticeDeck from "./observatory/PracticeDeck";
import Stillness from "./observatory/Stillness";
import { MotionToggle } from "./JourneyUX";
import HanumanSVG from "../components/HanumanSVG";
import "./observatory/devotion.css";
import Navratri from "./observatory/Navratri";

export function Founder({ full = false }: { full?: boolean }) {
  return (
    <section
      className={`founder-section container observatory-founder ${full ? "founder-full" : ""}`}
    >
      <figure className="founder-portrait">
        <img
          src={portrait}
          alt="Vaanii Jain, founder of Radian Soul"
          loading={full ? "eager" : "lazy"}
        />
        <figcaption>
          VAANII JAIN <span>Founder, Radian Soul</span>
        </figcaption>
      </figure>
      <div className="founder-copy">
        <p className="observatory-label">The person behind the practice</p>
        {full ? (
          <h1>
            A voice.
            <br />A listening ear.
            <br /><em>Vaanii.</em>
          </h1>
        ) : (
          <h2>
            A listening ear.
            <br />A guiding presence.
          </h2>
        )}
        <p>
          Radian Soul began with a simple intention: to create a compassionate
          space for clarity, reflection, and connection.
        </p>
        <p>
          I’m Vaanii Jain, a tarot reader and holistic healer. Whether you
          arrive with a specific question or simply a feeling that something
          needs to shift, we begin with where you are.
        </p>
        {full ? (
          <>
            <blockquote>
              “Born as Pooja Bolia, I embraced the name Vaanii Jain to represent
              my spiritual journey. For me, it symbolizes a voice of guidance
              and inner wisdom that I wish to share with you.”
            </blockquote>
            <a className="text-link" href="mailto:vaaniijain@radiansoul.com">
              vaaniijain@radiansoul.com <Arrow diagonal />
            </a>
          </>
        ) : (
          <Link className="text-link" to="/about">
            Meet Vaanii <Arrow />
          </Link>
        )}
      </div>
    </section>
  );
}
export default function Home() {
  return <div className="observatory-home">
    <section className="observatory-hero" aria-labelledby="observatory-title">
      <div className="hero-orbit-scene"><Scene large slug="tarot"/></div>
      <div className="observatory-hero-copy"><p className="observatory-label">Radian Soul / A space for the unseen</p><h1 id="observatory-title">Follow your<br/><em>inner cosmos.</em></h1><p>Tarot, healing & personal guidance.<br/>For everything you’re becoming.</p><a className="portal-button" href="#practices-heading"><span>Find your beginning</span><Arrow/></a></div>
      <div className="hero-orbit-label orbit-label-left"><span>01 — Clarity</span><i/><span>Look a little deeper.</span></div><div className="hero-orbit-label orbit-label-right"><span>02 — Connection</span><i/><span>Come a little closer.</span></div>
      <div className="observatory-hero-bottom container"><span>With Vaanii Jain</span><a href="#practices-heading">Enter the observatory ↓</a><span>Wonder is a good place to start.</span></div>
      <div className="mobile-hero-tools"><MotionToggle/></div>
    </section>
    <Navratri/>
    <PracticeDeck/>
    <section className="home-devotion container" aria-labelledby="devotion-title">
      <div className="devotion-seal"><HanumanSVG className="devotion-profile"/></div>
      <div className="devotion-copy">
        <p className="observatory-label">Rooted in devotion</p>
        <h2 id="devotion-title">A quiet strength <em>within.</em></h2>
        <p>Inspired by Hanuman ji’s devotion and courage. A space to explore spiritual practice, grounding and inner strength.</p>
        <Link className="portal-text-link" to="/services/hanuman-healing">Explore Hanuman ji healing <Arrow/></Link>
      </div>
    </section>
    <section className="founder-letter container"><div className="founder-letter-photo"><img src={portrait} alt="Vaanii Jain, founder of Radian Soul" loading="lazy"/><span className="handwritten">A person, before a practice.</span></div><div><p className="observatory-label">02 / The person you’ll meet</p><h2>Not all answers<br/>arrive as answers.<br/><em>Some begin as a conversation.</em></h2><p>I’m Vaanii, a tarot reader and holistic healer. I created Radian Soul as a space for personal guidance, thoughtful healing and the freedom to ask your own questions.</p><Link className="portal-text-link" to="/about">Meet the person behind the practice <Arrow/></Link></div></section>
    <Stillness/>
    <JournalTeaser/>
    <Reviews page="Home"/>
    <section className="observatory-invitation container"><p className="observatory-label">The next chapter is yours</p><h2>Shall we<br/><em>begin?</em></h2><a className="portal-button" href={whatsapp()} target="_blank" rel="noreferrer"><span>A conversation with Vaanii</span><Arrow diagonal/></a><p>Ask a question. Explore a practice.<br/>Take it at your own pace.</p></section>
  </div>;
}
